// extracted by mini-css-extract-plugin
export default {"prices":"style_prices__rw371","container":"style_container__-KEWC","title":"style_title__us2k3","banner":"style_banner__IeGWR"};